import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const RECEIPT_TOUR_ID = 'receipt';

export const receiptSteps: StepType[] = [
  {
    selector: '[data-tour="transfer-movements"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Toca cualquier movimiento para ver el <strong>detalle completo</strong> y descargar el
        comprobante en PDF.
      </MascotBubble>
    ),
  },
];
